<template>
  <div class="home">
    <!-- 标题 -->
    <el-row style="position: -webkit-sticky;position: sticky;top: 0px;z-index: 1000">
      <el-col :span="24">
        <div class="hzx_title">
          <div class="hzx_title_logo"></div>
          <div class="hzx_title_tag">
            <div class="hzx_title_tag_item" :style="{color: item.key === titleTag ? '#2394AF' : ''}" v-for="(item, index) in titleTagList" :key="index" @click="titleTag = item.key">
              {{ item.title }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div style="min-height: calc(100vh - 99px)">
      <!-- 轮播图 -->
      <el-row>
        <el-col :span="24">
          <div class="hzx_bg">
            <el-carousel trigger="click" height="550px">
              <el-carousel-item>
                <div class="carousel carousel1">
                  <div class="hzx_bg_title"></div>
                  <div class="hzx_bg_text">
                    <div>天津汇之禧信息技术有限公司</div>
                    <div class="hzx_bg_text_tip"></div>
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="carousel carousel2">
                  <div class="hzx_bg_text">
                    <div>天津汇之禧信息技术有限公司</div>
                    <div class="hzx_bg_text_tip"></div>
                  </div>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="carousel carousel3">
                  <div class="hzx_bg_text">
                    <div>天津汇之禧信息技术有限公司</div>
                    <div class="hzx_bg_text_tip"></div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>
      <!-- 关于我们 -->
      <el-row v-if="titleTag === '1'">
        <el-col :span="16" :offset="4">
          <Head :text1="'关于我们'" :text2="'ABOUS US'" :text3="'国内领先的智慧能源数字化应用集成商'"></Head>
          <div class="hzx_abous_us">
            <div class="hzx_abous_us_text">
              <span>
                天津汇之禧信息技术有限公司（以下简称“汇之禧”）公司立足高端IT技术，专注于
              </span>
              <span style="color: #2394AF; font-weight: 700;">
                打造电力领域智慧能源数字化应用服务管理专家
              </span>
              <span>
                ，致力于为电力企业提供
              </span>
              <span style="color: #2394AF; font-weight: 700;">
                智能制造、信息化建设、智能仓储、综合能源
              </span>
              <span>
                等方面的整体解决方案，全面提升用户信息化和智能化水平，为客户创造价值。
              </span>
            </div>
            <div class="hzx_abous_us_img"></div>
          </div>
        </el-col>
        <el-col :span="16" :offset="4">
          <div class="hzx_abous_content">
            <el-row>
              <el-col :span="8">
                <div class="hzx_abous_content_div" style="float: right; margin: 50px auto;">
                  <div class="hzx_abous_content_div_text1">2015y</div>
                  <div class="hzx_abous_content_div_chengli"></div>
                  <div class="hzx_abous_content_div_text2">成立时间</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="hzx_abous_content_div" style="margin: 50px auto">
                  <div class="hzx_abous_content_div_text1">100R</div>
                  <div class="hzx_abous_content_div_fuwu"></div>
                  <div class="hzx_abous_content_div_text2">服务团队</div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="hzx_abous_content_div" style="float: left; margin: 50px auto;">
                  <div class="hzx_abous_content_div_text1">5000W</div>
                  <div class="hzx_abous_content_div_zhuce"></div>
                  <div class="hzx_abous_content_div_text2">注册资本</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 产品中心 -->
      <el-row v-if="titleTag === '2'">
        <el-col :span="16" :offset="4">
          <Head :text1="'产品中心'" :text2="'Historical opportunity'" :text3="'国内领先的智慧能源数字化应用集成商'"></Head>
<!--          <div class="hzx_historical">
            <div class="hzx_historical_text">
              <div style="width: 100%;">
                <span class="hzx_historical_text_no"/>
                <span class="hzx_historical_text1">能源新基建：</span>
                <span class="hzx_historical_text2">随着分布式能源、用户侧储能、电动汽车等交互式能源设施快速发展，各种新型用能形式不断涌现；</span>
              </div>
              <div style="width: 100%;">
                <span class="hzx_historical_text_no"/>
                <span class="hzx_historical_text1">双碳政策：</span>
                <span class="hzx_historical_text2">随着我国双碳进程推进，清洁能源比例逐步加大，新型电力能源系统面临巨大挑战，需要协调统筹多种能源，提升电网的稳定性，提高能源使用效率，加快构建清洁低碳、安全高效的能源体系面临挑战和机遇。</span>
              </div>
            </div>
            <div class="hzx_historical_img"></div>
          </div>-->
          <div class="hzx_historical_img hzx_historical_img1"></div>
          <div class="hzx_historical_img hzx_historical_img2"></div>
          <div class="hzx_historical_img hzx_historical_img3"></div>
          <div class="hzx_historical_img hzx_historical_img4"></div>
        </el-col>
<!--        <el-col :span="16" :offset="4">
          <div class="hzx_historical_content">
            <el-row>
              <el-col :span="9">
                <div class="hzx_historical_content_img1"></div>
              </el-col>
              <el-col :span="15">
                <div class="hzx_historical_content_img2"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>-->
      </el-row>
      <!-- 市场前景 -->
      <el-row v-if="titleTag === '3'">
        <el-col :span="16" :offset="4">
          <Head :text1="'市场前景'" :text2="'MARKET PROSPECT'"></Head>
          <div class="hzx_market">
            <div class="hzx_market_text">
              <span>
                近年来受双碳目标驱动，随着各种新型用能形式不断涌现，需要协调统筹多种能源，提升电网的稳定性，提高能源使用效率，加快构建清洁低碳、安全高效的能源体系，对建设新型电力能源系统产生迫切需求，
              </span>
              <span style="color: #2394AF; font-weight: 700;">
                “十四五”规划全国电网总投资预计近3万亿元。其中，止2021年底，电力行业信息化市场规模已经超过1000亿元。
              </span>
              <span>
                预计电力信息通信将继续保持5年以上高速增长，“端、边、网、云、智”等各环节
              </span>
              <span style="color: #2394AF; font-weight: 700;">
                设备商、运营商有望持续受益，前景广阔。
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="16" :offset="4">
          <div class="hzx_market_content">
            <el-row :gutter="20">
              <el-col :span="16">
                <div class="hzx_market_content_img1"></div>
              </el-col>
              <el-col :span="8">
                <div class="hzx_market_content_img2"></div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 战略合作 -->
      <el-row v-if="titleTag === '4'">
        <el-col :span="16" :offset="4">
          <Head :text1="'战略合作'" :text2="'STRATEGIC COOPERATION'"></Head>
          <div class="hzx_strategic">
            <div class="hzx_strategic_logo">
              <div class="hzx_strategic_logo_img">
                <el-row>
                  <el-col :span="6" :offset="1">
                    <img src="../../assets/img/logo2@2x.png" style="width: 100%;margin-top: 60px;" alt="">
                  </el-col>
                  <el-col :span="5" :offset="1" style="text-align: center;">
                    <img src="../../assets/img/sanjiao@2x.png" style="width: 75%;height: 75%;margin-top: 70px;" alt="">
                  </el-col>
                  <el-col :span="9" :offset="1">
                    <img src="../../assets/img/logo3@2x.png" style="width: 100%;margin-top: 75px;" alt="">
                  </el-col>
                </el-row>
              </div>
              <div class="hzx_strategic_logo_footer">
                汇之禧&格力装备战略合作
              </div>
            </div>
          </div>
          <div class="hzx_strategic_text">
            <h4>国创智能</h4>
            <span>
              格力智能装备全国销售公司与天津汇之禧成立合资公司，并对合资公司
            </span>
            <span style="color: #2394AF; font-weight: 700;">
              在能源领域的独家品牌授权，共同开发电网领域的智能仓储、储能电池、工业自动化设备等项目
            </span>
            <span>
              ，双方借助合资公司平台，围绕电网的业务需求共同在智能仓储领域定向研发专利技术，为检储备基础建设提供智能化解决方案。
            </span>
            <span style="color: #2394AF; font-weight: 700;">
              汇之禧占比70%，格力智能装备占比30% 。
            </span>
          </div>
        </el-col>
      </el-row>
      <!-- 主要客户 -->
      <el-row v-if="titleTag === '5'">
        <el-col :span="16" :offset="4">
          <Head :text1="'主要客户'" :text2="'MAJOR CUSTOMERS'"></Head>
          <el-row :gutter="20">
            <el-col :span="6" class="hzx_major">
              <img src="../../assets/img/pic_guowang@2x.png" style="width: 100%;" alt="">
            </el-col>
            <el-col :span="6" class="hzx_major">
              <img src="../../assets/img/pic_nanfang@2x.png" style="width: 100%;" alt="">
            </el-col>
            <el-col :span="6" class="hzx_major">
              <img src="../../assets/img/pic_datang@2x.png" style="width: 100%;" alt="">
            </el-col>
            <el-col :span="6" class="hzx_major">
              <img src="../../assets/img/pic_huaneng@2x.png" style="width: 100%;" alt="">
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="hzx_major_img"></div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <!-- 联系我们 -->
      <el-row v-if="titleTag === '6'">
        <el-col :span="16" :offset="4">
          <Head :text1="'联系我们'" :text2="'CONTACT US'"></Head>
          <div class="hzx_contact"></div>
          <div class="hzx_contact_form">
            <div class="hzx_contact_form_title">
              在线留言
            </div>
            <div class="hzx_contact_form_content">
              <el-row>
                <el-col :span="18" :offset="3">
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="标题：" prop="name">
                      <el-input v-model="ruleForm.name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="留言内容：" prop="desc">
                      <el-input type="textarea" v-model="ruleForm.desc" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="留言人：" prop="namer">
                      <el-input v-model="ruleForm.namer" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：" prop="region">
                      <el-select v-model="ruleForm.region" placeholder="请选择活动区域" size="small">
                        <el-option label="男" value="1"></el-option>
                        <el-option label="女" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="电子邮件：" prop="email">
                      <el-input v-model="ruleForm.email" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button type="primary" size="mini" @click="submitForm()">保存</el-button>
                      <el-button size="mini" @click="$refs.ruleForm.resetFields()">重置</el-button>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部 -->
    <el-row>
      <el-col :span="24">
        <div class="hzx_footer">
          版权所有： 津ICP备20005336号-1
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from './component/Head'
export default {
  name: 'HomeView',
  components: {
    Head
  },
  data() {
    return {
      titleTag: '1',
      titleTagList: [
        {
          title: '关于我们',
          key: '1'
        },
        {
          title: '产品中心',
          key: '2'
        },
        {
          title: '市场前景',
          key: '3'
        },
        {
          title: '战略合作',
          key: '4'
        },
        {
          title: '主要客户',
          key: '5'
        },
        {
          title: '联系我们',
          key: '6'
        }
      ],
      ruleForm: {
        name: '',
        desc: '',
        namer: '',
        region: '1',
        email: ''
      },
      rules: {
        name: { required: true, message: '请输入标题', trigger: 'blur' },
        desc: { required: true, message: '请输入留言内容', trigger: 'blur' },
        namer: { required: true, message: '请输入留言人', trigger: 'blur' },
        region: { required: true, message: '请选择性别', trigger: 'blur' },
        email: [
          { required: true, message: '请输入电子邮件', trigger: 'blur' },
          { type: 'email', message: '请输入正确的电子邮件', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$message.success('提交成功')
          this.$refs.ruleForm.resetFields()
        }
      })
    }
  },
}
</script>
<style scoped lang="scss">
.home {
  .hzx_title {
    width: 100%;
    height: 60px;
    background-color: #202020;
    margin-bottom: -1px;
    overflow: hidden;
    .hzx_title_logo {
      display: inline-block;
      margin-left: 30px;
      margin-top: 10px;
      width: 440px;
      height: 40px;
      background-image: url('../../assets/img/logo1.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .hzx_title_tag {
      float: right;
      margin-right: 30px;
      .hzx_title_tag_item {
        display: inline-block;
        width: 120px;
        height: 100%;
        line-height: 60px;
        color: #fff;
        cursor: pointer;
      }
      .hzx_title_tag_item:hover {
        color: rgba(35, 148, 175, .75);
      }
    }
  }
  .hzx_bg {
    height: 550px;
    .carousel {
      position: relative;
      width: 100%;
      height: 100%;
      background-size: 100% 100%;
      .hzx_bg_title {
        position: absolute;
        top: 50%;
        left:50%;
        transform: translate(-50%,-50%);
        width: 1200px;
        height: 256px;
        background-color: rgba(35, 148, 175, .75);
      }
      .hzx_bg_text {
        margin-top: 60px;
        position: absolute;
        top: 50%;
        left:50%;
        transform: translate(-50%,-50%);
        width: 1200px;
        height: 256px;
        font-size: 70px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        .hzx_bg_text_tip {
          margin: 60px auto;
          width: 120px;
          height: 8px;
          background-color: #fff;
        }
      }
    }
    .carousel1 {
      background-image: url('../../assets/img/bg1.png');
    }
    .carousel2 {
      background-image: url('../../assets/img/banner2@2x.png');
    }
    .carousel3 {
      background-image: url('../../assets/img/banner3@2x.png');
    }
  }
  .hzx_abous_us {
    margin-top: 40px;
    width: 100%;
    height: 150px;
    border: 1px solid #c1c1c1;
    .hzx_abous_us_text {
      padding: 30px 40px;
      vertical-align: top;
      display: inline-block;
      width: calc(100% - 300px);
      height: 100%;
      line-height: 30px;
    }
    .hzx_abous_us_img {
      vertical-align: top;
      display: inline-block;
      width: 220px;
      height: 100%;
      background-image: url('../../assets/img/pic1.png');
      background-size: 100% 100%;
    }
  }
  .hzx_abous_content {
    position: relative;
    margin: 30px auto;
    width: 100%;
    height: 400px;
    border: 1px solid #c1c1c1;
    .hzx_abous_content_div {
      width: 240px;
      height: 300px;
      background-color: #2394AF;
      text-align: center;
      overflow: hidden;
      .hzx_abous_content_div_text1 {
        margin-top: 60px;
        color: #fff;
        font-weight: 700;
        font-size: 20px;
      }
      .hzx_abous_content_div_text2 {
        margin-top: 40px;
        color: #fff;
        font-weight: 700;
        font-size: 20px;
      }
      .hzx_abous_content_div_chengli {
        margin: 30px auto;
        width: 60px;
        height: 60px;
        background-image: url('../../assets/img/icon_chengli.png');
        background-size: 100% 100%;
      }
      .hzx_abous_content_div_fuwu {
        margin: 30px auto;
        width: 60px;
        height: 60px;
        background-image: url('../../assets/img/icon_fuwu.png');
        background-size: 100% 100%;
      }
      .hzx_abous_content_div_zhuce {
        margin: 30px auto;
        width: 60px;
        height: 60px;
        background-image: url('../../assets/img/icon_zhuce.png');
        background-size: 100% 100%;
      }
    }
  }
  .hzx_historical_img {
    margin: 20px auto;
    width: 100%;
    background-size: 100% 100%;
  }
  .hzx_historical_img1 {
    background-image: url('../../assets/img/WX20220906173233.png');
    height: 700px;
  }
  .hzx_historical_img2 {
    background-image: url('../../assets/img/WX20220906173324.png');
    height: 700px;
  }
  .hzx_historical_img3 {
    background-image: url('../../assets/img/WX20220906173345.png');
    height: 600px;
  }
  .hzx_historical_img4 {
    background-image: url('../../assets/img/WX20220906173404.png');
    height: 800px;
  }
  .hzx_historical {
    margin-top: 40px;
    width: 100%;
    height: 150px;
    border: 1px solid #c1c1c1;
    .hzx_historical_text {
      padding: 30px 40px;
      vertical-align: top;
      display: inline-block;
      width: calc(100% - 300px);
      height: 100%;
      line-height: 30px;
      div {
        text-overflow: -o-ellipsis-lastline;
        padding-left: 10px;
        overflow: hidden;				//溢出内容隐藏
        text-overflow: ellipsis;		//文本溢出部分用省略号表示
        display: -webkit-box;			//特别显示模式
        -webkit-line-clamp: 2;			//行数
        line-clamp: 2;
        -webkit-box-orient: vertical;	//盒子中内容竖直排列
        .hzx_historical_text_no {
          display: inline-block;
          margin-right: 20px;
          width: 10px;
          height: 10px;
          background-color: #2394af;
          transform: rotate(45deg);
          z-index: 1000;
        }
        .hzx_historical_text1 {
          display: inline-block;
          margin-right: 5px;
          font-weight: 700;
        }
        .hzx_historical_text2 {
        }
      }
    }
    .hzx_historical_img {
      vertical-align: top;
      display: inline-block;
      width: 220px;
      height: 100%;
      background-image: url('../../assets/img/pic2.png');
      background-size: 100% 100%;
    }
  }
  .hzx_historical_content {
    position: relative;
    margin: 50px auto;
    width: 100%;
    height: 600px;
    /*border: 1px solid #c1c1c1;*/
    .hzx_historical_content_img1 {
      width: 100%;
      height: 600px;
      background-image: url('../../assets/img/pic4.png');
      background-size: 100% 100%;
      border: 1px #ccc dashed;
    }
    .hzx_historical_content_img2 {
      margin: 50px 50px 0px;
      width: calc(100% - 50px);
      height: 500px;
      background-image: url('../../assets/img/pic5.png');
      background-size: 100% 100%;
      border: 1px #ccc dashed;
    }
  }
  .hzx_market {
    margin-top: 40px;
    width: 100%;
    min-height: 150px;
    border: 1px solid #c1c1c1;
    .hzx_market_text {
      padding: 30px 40px;
      vertical-align: top;
      display: inline-block;
      width: calc(100% - 80px);
      height: 100%;
      line-height: 30px;
      text-align: center;
      div {
        text-overflow: -o-ellipsis-lastline;
        padding-left: 10px;
        overflow: hidden;				//溢出内容隐藏
        text-overflow: ellipsis;		//文本溢出部分用省略号表示
        display: -webkit-box;			//特别显示模式
        -webkit-line-clamp: 2;			//行数
        line-clamp: 2;
        -webkit-box-orient: vertical;	//盒子中内容竖直排列
        .hzx_market_text_no {
          display: inline-block;
          margin-right: 20px;
          width: 10px;
          height: 10px;
          background-color: #2394af;
          transform: rotate(45deg);
          z-index: 1000;
        }
      }
    }
  }
  .hzx_market_content {
    position: relative;
    margin: 50px auto;
    width: 100%;
    height: 440px;
    /*border: 1px solid #c1c1c1;*/
    .hzx_market_content_img1 {
      width: 100%;
      margin: 20px auto;
      height: 400px;
      background-image: url('../../assets/img/pic6.png');
      background-size: 100% 100%;
      border: 1px #ccc dashed;
    }
    .hzx_market_content_img2 {
      width: calc(100%);
      height: 440px;
      background-image: url('../../assets/img/pic7.png');
      background-size: 100% 100%;
      border: 1px #ccc dashed;
    }
  }
  .hzx_strategic{
    position: relative;
    width: 100%;
    margin: 40px auto;
    height: 550px;
    background-image: url('../../assets/img/pic8@2x.png');
    background-size: 100% 100%;
    .hzx_strategic_logo {
      width: 60%;
      height: 50%;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left:50%;
      transform: translate(-50%,-50%);
      .hzx_strategic_logo_img {
        margin: 0 auto;
        width: 100%;
        height: 75%;
      }
      .hzx_strategic_logo_footer {
        width: 100%;
        height: 25%;
        background-color: #2394af;
        color: #fff;
        font-size: 40px;
        text-align: center;
        line-height: 69px;
      }
    }
  }
  .hzx_strategic_text {
    margin-top: 20px;
    margin-bottom: 40px;
    width: 100%;
    span {
      line-height: 40px;
    }
  }
  .hzx_major {}
  .hzx_major_img {
    margin: 50px auto;
    width: 100%;
    height: 350px;
    background-image: url('../../assets/img/pic_buju@2x.png');
    background-size: 100% 100%;
    border: 1px #ccc solid;
  }
  .hzx_contact {
    margin: 50px auto;
    width: 100%;
    height: 600px;
    background-image: url('../../assets/img/pic_map@2x.png');
    background-size: 100% 100%;
  }
  .hzx_contact_form {
    margin-bottom: 50px;
    .hzx_contact_form_title {
      height: 60px;
      line-height: 60px;
      font-size: 22px;
      padding-left: 40px;
      border-left: 5px #2394af solid;
      margin-bottom: 50px;
      font-weight: 700;
    }
  }
  .hzx_footer {
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    color: rgba(255, 255, 255, .51);
    background-color: #202020;
  }
  ::v-deep .el-carousel__button {
    width: 8px;
    height: 8px;
    border-radius: 3px;
  }
  ::v-deep .is-active {
    .el-carousel__button {
      background-color: #2394AF
    }
  }
  ::v-deep .el-form-item {
    margin-bottom: 18px !important;
  }
}
</style>
